import ResetPasswordForm from '@/redux/auth/ResetPassword/ResetPasswordForm';

function ResetPassword() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <ResetPasswordForm />
    </div>
  );
}

export default ResetPassword;
